<ng-container *ngIf="actions$ | async as actions; else loading">
  <button mat-menu-item *ngFor="let action of actions" (click)="openActionDialog(action, planInstanceId)">
    <mat-icon class="ics" [svgIcon]="action" [matTooltip]="getTranslation(action)" matTooltipPosition="above"></mat-icon>
    <span>{{ getTranslation(action) }}</span>
  </button>
</ng-container>
<ng-template #loading>
  <mat-spinner diameter="30"></mat-spinner>
</ng-template>
